/**
 * Switch to selected page.
 */
function collapsible_card(){

    var coll = document.getElementsByClassName("collapsible_card");
    var i;
    
    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var content = this.nextElementSibling;
        if (content.style.maxHeight){
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        } 
      });
    }
}

collapsible_card();

export default collapsible_card;